"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useDebounce = require("use-debounce");
var _constants = require("../../constants");
var _navigation = require("../../context/navigation");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _models = require("../../models");
var _utils = require("../../utils");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SearchInput = () => {
  const {
    activeMenu,
    hideSearchResultsTab
  } = (0, _navigation.useActiveMenu)();
  const {
    hide,
    blur,
    clearResults,
    value,
    setValue,
    manualHide,
    isFocused,
    searchHistory,
    mode
  } = (0, _navigation.useSearchInput)();
  const isMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.SearchResults;
  const isMobile = (0, _hooks.useIsMobile)();
  const inputRef = (0, _react.useRef)(null);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  (0, _utils2.useRemoveBodyScroll)(isMenuActive && isMobile);
  const throttledAnalytics = (0, _useDebounce.useThrottledCallback)(() => UserAction.dispatch(_constants.START_SEARCH), _constants.SEARCH_THROTTLE_TIME);
  const onChangeHandler = (0, _react.useCallback)(({
    target
  }) => {
    const isValueEmpty = target.value.length === 0;
    setValue(target.value);
    throttledAnalytics();
    if (!isValueEmpty && !isMenuActive) {
      (0, _utils.dispatchToggleMenu)(ToggleMenuFlyout.MenuTypes.SearchResults);
    }
  }, [setValue, throttledAnalytics, isMenuActive]);
  const closeSearch = (0, _react.useCallback)(() => {
    manualHide();
    hide();
    hideSearchResultsTab();
  }, [hide, hideSearchResultsTab, manualHide]);
  const clearInput = (0, _react.useCallback)(() => {
    setValue('');
    clearResults();
  }, [clearResults, setValue]);
  const handleOnBlur = (0, _react.useCallback)(() => {
    if (!value && mode === _models.SearchPreviewMode.Results) {
      blur();
    }
  }, [blur, mode, value]);
  (0, _presentationHooks.useListenToKeyDown)(['Escape'], () => {
    if (isFocused) {
      inputRef.current?.blur();
      handleOnBlur();
      closeSearch();
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SearchInputBox, {
    "data-testid": getTestId(_constants2.SEARCH_INPUT_BOX),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Search, {
      fontSize: "medium",
      "data-testid": getTestId(_constants2.SEARCH)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInputInput, {
      ref: inputRef,
      autoFocus: isFocused,
      type: "text",
      placeholder: translations.searchDesktop,
      value: value,
      "aria-label": translations.search,
      "data-testid": getTestId(_constants2.SEARCH_INPUT),
      onChange: onChangeHandler,
      onBlur: handleOnBlur,
      onKeyDown: (0, _utils2.onEnterPressHandler)(searchHistory.addSearchItem)
    }), value && isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInputClear, {
      disableRipple: true,
      "aria-label": translations.clearSearchInput,
      "data-testid": getTestId(_constants2.SEARCH_INPUT_CLEAR),
      isFocused: isFocused,
      onClick: clearInput,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
        fontSize: "inherit"
      })
    }) : null]
  });
};
exports.SearchInput = SearchInput;
